<template>
	<div class="card border-0 card-with-shadow">
		<div class="card-header bg-transparent p-primary d-flex justify-content-between align-items-center">

			<h5 v-show="isDetailsActive" class="card-title text-muted mb-0">{{ $t('details_soc') }}</h5>
			<h5 v-show="!isDetailsActive" class="card-title text-muted mb-0">{{ $t('edit_details') }}</h5>

			<div>
				<a v-show="!isDetailsActive" class="text-muted" href="#" @click.prevent="detailsInfoClose">
					<app-icon name="x-square" stroke-width="1"/>
				</a>
				<a v-show="!isDetailsActive" class="text-muted" href="#" @click.prevent="detailsInfoSync">
					<app-icon name="check-square" stroke-width="1"/>
				</a>
				<a v-show="isDetailsActive" class="text-muted" href="#" @click.prevent="detailsInfoEdit">
					<app-icon name="edit" stroke-width="1"/>
				</a>
			</div>

		</div>
		<div class="card-body">

			<div v-show="isDetailsActive">
				
				<div v-if="detailsData.fb" class="form-group mb-3">
					<div class="form-row">
						<label class="mb-0 text-muted col-12 d-flex align-items-center">
							<a 
							   :href="detailsData.fb">
								Facebook</a>
						</label>
					</div>
				</div>
				<div  v-if="detailsData.insta" class="form-group mb-3">
					<div class="form-row">
						<label class="mb-0 text-muted col-12 d-flex align-items-center">
							<a 
							   :href="detailsData.insta">
								Instagram</a>
						</label>
					</div>
				</div>
				
				
				
				
			</div>

			<div v-show="!isDetailsActive">
				
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('Facebook') }}</label>
						<div class="col-7">
							<app-input v-model="detailsData.fb"
							           :error-message="$errorMessage(errors, 'fb')"
							           type="text"/>
						</div>
					</div>
				</div>
				<div class="form-group mb-3">
					<div class="form-row">
						<label class="col-5 mb-0 d-flex align-items-center">{{ $t('Instagram') }}</label>
						<div class="col-7">
							<app-input v-model="detailsData.insta"
							           :error-message="$errorMessage(errors, 'insta')"
							           type="text"/>
						</div>
					</div>
				</div>



			</div>

		</div>
	</div>
</template>

<script>

import {FormMixin} from "@core/mixins/form/FormMixin.js";
import { formatDateToLocal, urlGenerator} from "@app/Helpers/helpers";

export default {
	name: "DetailsInformation",
	mixins: [FormMixin],
	props: {
		detailsData: {
			type: Object,
			required: true
		},
		detailsSyncUrl: {
			type: String,
			required: true
		}
	},
	data() {
		return {
			urlGenerator,
			formatDateToLocal,
			isDetailsActive: true,
			formData: {},
			errors: {}
		}
	},
	computed: {
		contentTypeList() {
			return this.$store.getters.contentType
		},
		ownerList() {
			return this.$store.getters.getOwner
		}
	},
	methods: {
		detailsInfoSync() {

			this.formData.name = this.detailsData.name;
			this.formData.sex = this.detailsData.sex;
			this.formData.fb = this.detailsData.fb;
			this.formData.insta = this.detailsData.insta;
			this.formData.age = this.detailsData.age;
			this.formData.contact_type_id = this.detailsData.contact_type_id;
			this.formData.owner_id = this.detailsData.owner_id;
			this.submitFromFixin('patch', this.detailsSyncUrl, this.formData);
		},

		afterError(response) {
			this.errors = response.data.errors
		},

		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.isDetailsActive = true
			this.errors = {}
			this.$emit('update-request');
		},

		detailsInfoClose() {
			this.isDetailsActive = true;
		},
		detailsInfoEdit() {
			this.isDetailsActive = false
		},
	},
	created() {
		this.$store.dispatch('contentType');
		this.$store.dispatch('getOwner');
	},
}
</script>

